import { isOrvalServerError, isOrvalServiceUnavailableError } from '@r/api/orval-error-helper.ts';

/** Motif affiché sur la page maintenance (badge). */
export type MaintenancePageReason = '500' | '503';

/** 500 (whitelist + retries) ou 503 (maintenance plateforme) → page maintenance. */
export function shouldShowMaintenancePage(error: unknown): boolean {
  return isOrvalServerError(error) || isOrvalServiceUnavailableError(error);
}

export function getMaintenancePageReason(error: unknown): MaintenancePageReason {
  if (isOrvalServiceUnavailableError(error)) {
    return '503';
  }
  return '500';
}
